const IS_DEBUG_MODE = 'IS_DEBUG_MODE';

export { IS_DEBUG_MODE };
